import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import ICU from 'i18next-icu';

i18n
  .use(Backend)  // Load translations from /locales
  .use(LanguageDetector)  // Detect user language
  .use(ICU)  // Enable ICU MessageFormat (plural/ordinal)
  .use(initReactI18next)  // React bindings
  .init({
    supportedLngs: ['da', 'en'],
    fallbackLng: 'en',  // English fallback for missing translations
    load: 'languageOnly',  // Use 'da' not 'da-DK'
    debug: import.meta.env.DEV,

    // Namespace configuration
    ns: ['common', 'auth', 'matches', 'players', 'seasons', 'admin', 'dashboard', 'validation', 'errors', 'tournaments'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      // Detection order
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Default new users to Danish
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('da');
}

export default i18n;
